import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 3h18v2H3V3z"
}), 'MaximizeSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MaximizeSharp.js
// module id = 4789
// module chunks = 2